import { RegistrationType } from "./../models/UserEnums";

export function getRegistrationTypeTranslation(
  value: RegistrationType | null
): string {
  switch (value) {
    case null:
      return "";
    case RegistrationType.NewCustomer:
      return "Nový klient";
    case RegistrationType.ExistingCustomer:
      return "Stávající klient";
    case RegistrationType.AdminCustomer:
      return "Spravuji jízdy více klientům";
    default:
      return value;
  }
}
